<template>
  <v-col cols="12" v-if="permisoVista('permisos', 'r')">
    <template>
      <v-row justify="center">
        <v-dialog
          v-model="eliminar"
          persistent
          max-width="500px"
          :key="eliminar"
        >
          <v-card>
            <v-card-title class="headline"
              >¿Está seguro que desea eliminar esta Rol?</v-card-title
            >
            <v-card-text
              >Esta acción no se puede revertir y será permanente.</v-card-text
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="
                  eliminar = false;
                  delItem = '';
                "
                >Cancelar</v-btn
              >
              <v-btn
                color="red darken-1"
                text
                @click="
                  eliminar = false;
                  deleteItemDB();
                "
                >Aceptar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
    <v-data-table
      :headers="headers"
      :items="roles"
      :search="search"
      :loading="loading"
      loading-text="Cargando... Espere, Por Favor."
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-dialog v-model="dialog" persistent fullscreen :key="dialog">
            <template v-slot:activator="{ on }">
              <v-btn
                v-if="permisoVista('permisos', 'c')"
                color="primary"
                dark
                class="mb-2"
                v-on="on"
                :disabled="loading"
                >Nuevo Rol</v-btn
              >
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col justify="center" cols="12" sm="12" md="12">
                      <v-text-field
                        v-model="editedItem.nombre"
                        label="Nombre del Rol"
                        :error-messages="errores[0]"
                        @focus="errores[0]=''"
                      ></v-text-field>
                    </v-col>
                    <v-col justify="center" cols="12" sm="12" md="12">
                      <v-text-field
                        v-model="editedItem.descripcion"
                        label="Descripción del Rol"
                        :error-messages="errores[1]"
                        @focus="errores[1]=''"
                      ></v-text-field>
                    </v-col>
                    <v-col justify="center" cols="12" sm="12" md="12">
                      <v-autocomplete
                        v-model="editedItem.idsReportes"
                        label="Reportes"
                        item-value="idReporte"
                        item-text="nombre"
                        multiple
                        chips
                        deletable-chips
                        :items="reportes"
                      >

                      </v-autocomplete>
                    </v-col>
                    <v-col justify="center" cols="12" sm="12" md="12">
                      <v-card>
                        <v-tabs vertical>
                          <v-tab
                            v-for="(seccion, index) in secciones"
                            :key="index + 1"
                          >
                            <v-icon>{{ seccion.icono }}</v-icon>
                            {{ seccion.nombre }}
                          </v-tab>
                          <v-tab-item
                            v-for="(seccion, index) in secciones"
                            :key="index + 1"
                          >
                            <v-card flat>
                              <v-card-text>
                                <v-data-table
                                  v-model="selected"
                                  :items="seccion.vistas"
                                  :headers="headerPermisos"
                                  hide-default-footer
                                  show-select
                                  item-key="idVista"
                                  :items-per-page="-1"
                                  @item-selected="seleccionaFila"
                                  @toggle-select-all="seleccionaColumna"
                                  checkbox-color="primary"
                                >
                                  <template v-for="(head,idx) in headerPermisos" v-slot:[`item.${head.value}`]="{ item }">
                                    <p 
                                      v-if="head.value=='nombre'"
                                      :key="`nom-${idx}`" 
                                      class="mb-0"
                                      >{{item.nombre}}</p
                                    >
                                    <v-checkbox
                                      v-else
                                      v-model="
                                        permisos[item.idVista][
                                          idx
                                        ]
                                      "
                                      :key="`simp-${item.idVista}-${idx}`"
                                      color="blue darken-2"
                                    ></v-checkbox>
                                  </template>
                                  <!-- <template v-slot:body="{ items }">
                                  <tbody>
                                      <tr v-for="item in items" :key="item.id">
                                          <td>
                                              <v-checkbox 
                                                v-model="filas[item.idVista]"
                                                style="margin:0px;padding:0px"
                                                hide-details 
                                              />
                                          </td>
                                          <td></td>
                                          <td>{{ item.nombre }}</td>
                                          <td
                                            v-for="(accion, index) in acciones"
                                            :key="index + 1"
                                          >
                                            <v-checkbox
                                              v-model="
                                                permisos[item.idVista][
                                                  accion.idAccion
                                                ]
                                              "
                                              color="blue darken-2"
                                            ></v-checkbox>
                                          </td>
                                      </tr>
                                  </tbody>
                                  </template> -->
                                </v-data-table>
                              </v-card-text>
                            </v-card>
                          </v-tab-item>
                        </v-tabs>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close()"
                  >Cancelar</v-btn
                >
                <v-btn
                  color="red darken-1"
                  text
                  @click="save()"
                  :disabled="saving"
                  :loading="saving"
                >
                  Guardar
                  <template v-slot:loader>
                    <v-progress-circular
                      indeterminate
                      :width="2"
                      :size="24"
                      color="red"
                    ></v-progress-circular>
                  </template>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Buscar"
            single-line
            :disabled="loading"
            hide-details
          ></v-text-field>
        </v-toolbar>
      </template>
      <template v-if="headers.some(h => h.value === 'alarmaParo')" v-slot:[`item.alarmaParo`]="{ item }">
        <v-switch
          v-model="item.alarmaParo"
          inset
          :disabled="item.tieneDatos === false"
          @change="valor => onAlarmaParoChange(item, valor)"
        />
      </template>
     <template v-if="headers.some(h => h.value === 'llamarMantenimiento')" v-slot:[`item.llamarMantenimiento`]="{ item }">
        <v-switch
          v-model="item.llamarMantenimiento"
          inset
          :disabled="item.tieneDatos === false"
          @change="activar => onLlamadoOPSChange(item, activar)">
        </v-switch>
        </template>
        <template v-slot:[`item.action`]="{ item }">
        <!-- Icono de Editar -->
        <v-tooltip bottom color="black" class="white--text">
          <template v-slot:activator="{ on }">
            <v-icon
              v-on="on"
              v-if="permisoVista('permisos', 'u')"
              small
              class="mr-2"
              :disabled="loading"
              @click="editItem(item)"
            >
              edit
            </v-icon>
          </template>
          <span class="white--text">Editar</span>
        </v-tooltip>

        <!-- Icono de Eliminar -->
        <v-tooltip bottom  class="white--text">
          <template v-slot:activator="{ on }">
            <v-icon
              v-on="on"
              v-if="permisoVista('permisos', 'd')"
              small
              class="mr-2"
              :disabled="loading"
              @click="deleteItem(item)"
            >
              delete
            </v-icon>
          </template>
          <span class="white--text">Eliminar</span>
        </v-tooltip>

        <!-- NUEVO ICONO: Configuración de alerta (solo para Nyx)
        <v-tooltip v-if="nombreEmpresa === 'Nyx' || nombreEmpresa === 'Glm'" bottom color="black" class="white--text">
          <template v-slot:activator="{ on }">
            <v-icon
              v-on="on"
              small
              class="mr-2"
              @click="abrirDialogAlerta(item)"
            >
              notifications
            </v-icon>
          </template>
          <span class="white--text">Configurar alerta</span>
        </v-tooltip> -->
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Refrescar</v-btn>
      </template>
    </v-data-table>
    <v-snackbar v-model="alerta" top color="error">
      Existe un Rol Activo con el mismo nombre
      <v-btn text @click="alerta = false"> Cerrar </v-btn>
    </v-snackbar>
    
    <v-dialog v-model="dialogAlerta" max-width="400">
        <v-card>
          <v-card-title>Configurar Aviso Operativo</v-card-title>
          <v-card-subtitle class="text-body-2 text--secondary">
            Estos avisos notifican al personal cuando se requiere revisión o asistencia.
          </v-card-subtitle>
          <v-card-text>
            <v-row dense class="align-center justify-space-around">
              <v-col cols="6" class="pa-1">
                <v-checkbox
                  v-model="configAlerta.correo"
                  label="Correo"
                  color="primary"
                  hide-details
                  dense
                  class="ma-0 pa-0"
                ></v-checkbox>
              </v-col>
              <v-col cols="6" class="pa-1">
                <v-checkbox
                  v-model="configAlerta.sms"
                  label="Mensaje"
                  color="primary"
                  hide-details
                  dense
                  class="ma-0 pa-0"
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="blue" @click="cerrarDialogAlerta()">Cancelar</v-btn>
            <v-btn text color="green" @click="guardarConfiguracionAlerta()">Guardar</v-btn>
          </v-card-actions>
          <!--<v-row v-if="mensajeErrorAlarma" class="mt-2">
            <v-col cols="12">
              <v-alert type="error" dense outlined>
                {{ mensajeErrorAlarma }}
              </v-alert>
            </v-col>
          </v-row>-->
        </v-card>
    </v-dialog>
    <v-dialog v-model="showModal" max-width="800">
      <v-card>
        <v-card-title>Configurar Alarma de Paro</v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <!-- Área y Usuario -->
              <v-col cols="6">
                <v-select
                  v-model="alarma.areaSeleccionada"
                  :items="areas"
                  item-text="nombre"
                  item-value="idArea"
                  label="Seleccione las Áreas [Opcional]"
                  multiple
                  chips
                />
              </v-col>
              <!--<v-col cols="6">
                <v-select
                  v-model="alarma.usuarioSeleccionado"
                  :items="usuarios"
                  item-text="nombre"
                  item-value="idUsuario"
                  label="Seleccione el Usuario"
                  @change="onUsuarioChange"
                  :disabled="!alarma.areaSeleccionada"
                />
              </v-col>-->

              <!-- Turno y Máquinas -->
              <v-col cols="6">
               <v-select
                  v-model="alarma.turnoSeleccionado"
                  :items="alarma.listaTurnos"
                  item-text="nombre"
                  item-value="idTurno"
                  label="Seleccione los Turnos [Opcional]"
                  multiple
                  chips
                />
              </v-col>
              <v-col cols="6">
                <v-select
                  v-model="alarma.maquinasSeleccionadas"
                  :items="maquinasIns"
                  :item-text="nombreMaquina"
                  item-value="idMaquinaIns"
                  label="Seleccione las Máquinas [Opcional]"
                  multiple
                  chips
                />
              </v-col>

              <!-- Tiempo y Medio -->
              <v-col cols="6">
                <v-select
                  v-model="alarma.tiempoSeleccionado"
                  :items="tiempos"
                  item-text="text"
                  item-value="value"
                  label="Tiempo de la Alarma [Opcional]"
                  hint="Tiempo que debe tener la máquina de paro para enviar la alerta
                  *Vacio se enviaran siempre"
                  persistent-hint
                  clearable
                />
              </v-col>
              <v-col cols="6">
                <v-select
                  v-model="alarma.medioEnvio"
                  :items="[
                    { text: 'Whatsapp', value: 1 },
                    { text: 'Telegram', value: 2 },
                    { text: 'SMS', value: 3 }
                  ]"
                  label="Seleccione los Medios de Envío [Opcional]"
                  hint="*Vacio sera enviado por todos los medios"
                  persistent-hint
                  multiple
                  chips
                />
              </v-col>
              <v-col cols="12" md="5">
                <v-text-field
                    v-model="alarma.tiempoAcumulado"
                    label="Tiempo de la Alarma Acumulado en Minutos [Opcional]"
                    hint="Tiempo acumulado para enviar alerta *Vacío se enviarán siempre"
                    persistent-hint
                    clearable
                    type="number"
                />
              </v-col>

              <!-- Activo alineado -->
              <v-col cols="12" class="d-flex justify-end">
                <v-switch
                  v-model="alarma.activo"
                  label="Activo"
                  color="success"
                />
              </v-col>

            </v-row>
            <!--<v-row v-if="mensajeErrorAlarma" class="mt-3">
              <v-col cols="12">
                <v-alert type="error" dense outlined>
                  {{ mensajeErrorAlarma }}
                </v-alert>
              </v-col>
            </v-row>-->
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" @click="cancelarActivacion">Cancelar</v-btn>
          <v-btn color="blue" @click="confirmarActivacion">Guardar</v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>
  </v-col>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";

export default {
  data(){
    return {
      //mensajeErrorAlarma: "",
      showModal: false,
      currentItem: null,
      alarma: {
        areaSeleccionada: [],
        turnoSeleccionado: [],
        listaTurnos: [],
        maquinasSeleccionadas: [],
        tiempoSeleccionado: null,  // este sigue siendo único
        medioEnvio: [],
        tiempoAcumulado: null,
        activo: true
      },
      configurandoDesdeSwitch: false,
      areas: [],
      usuarios: [],
      maquinasIns: [],
      tiempos: [ {text:'10 min',value:1}, {text:'30 min', value:2}, {text:'60 min',value:3}, {text:'2 hrs',value:4}],
      loadingRoles: false,
      loadingReportes: false,
      reportes:[],
      selected: [],
      contadorSec: 0,
      contador: 0,
      filas: [],
      seleccionados: [],
      saving: false,
      dialog: false,
      alerta: false,
      eliminar: false,
      search: "",
      roles: [],
      loadingInfo: false,
      acciones: [],
      secciones: [],
      delItem: "",
      errores: [],
      permisos: [],
      editedIndex: -1,
      editedItem: {
        nombre: "",
        descripcion: "",
        idsReportes:[],
      },
      defaultItem: {
        nombre: "",
        descripcion: "",
        idsReportes:[]
      },
      dialogAlerta: false,
      configAlerta: {
        idRol: null,
        correo: false,
        sms: false
      },
    }
  },
  computed: {
    ...mapState({
      desconocidos: "desconocidos",
      desconocidosIds: "desconocidosIds",
      nombreEmpresa: "nombreEmpresa",
    }),
    loading(){
      return this.loadingRoles || this.loadingReportes || this.loadingInfo;
    },
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo Rol" : "Editar Rol";
    },
    headerPermisos() {
      let headers = [];
      headers.push({
        text: "Vista",
        align: "center",
        sortable: false,
        value: "nombre",
      });
      this.acciones.forEach(function (element) {
        headers.push({
          text: element.nombre,
          align: "center",
          sortable: false,
          value: element.nombre,
        });
      });
      return headers;
    },
    headers() {
      const baseHeaders = [
        { text: "Rol", value: "nombre", align: "left", sortable: true }
      ];

      //if (this.nombreEmpresa === "Nyx" || this.nombreEmpresa === 'Glm') {
      baseHeaders.push({
        text: "Paro Alarma",
        value: "alarmaParo",
        align: "center",
        sortable: false
      });
      //}

      //if (this.nombreEmpresa === "Nyx" || this.nombreEmpresa === 'Glm') {
      baseHeaders.push({
        text: "Llamado OPS",
        value: "llamarMantenimiento",
        align: "center",
        sortable: false
      }); 
      //}

      baseHeaders.push({
        text: "Acciones",
        value: "action",
        sortable: false,
        align: "center"
      });

      return baseHeaders;
    }
  },

  mounted() {
    this.initialize();
  },
  methods: {
    nombreMaquina(maquina) {
      if (!maquina) return '';
      return `[${maquina.nombre}] - ${maquina.marca ?? ''} ${maquina.modelo ?? ''}`;
    },
    onLlamadoOPSChange(item, activar) {
      this.configAlerta.idRol = item.idRol;
      this.configurandoDesdeSwitch = true;
      this.currentItem = item;

      if (activar) {
        // Primero cargamos datos previos si existen
        axios.get(`/Permisos/ObtenerAlertaMantenimiento/${item.idRol}`)
          .then(response => {
            this.configAlerta.correo = response.data.correo;
            this.configAlerta.sms = response.data.celular;
          })
          .catch(() => {
            // En caso de que no exista configuración previa
            this.configAlerta.correo = false;
            this.configAlerta.sms = false;
          })
          .finally(() => {
            // Ahora sí abrimos el modal
            this.dialogAlerta = true;
          });
      } else {
        // Desactivación directa sin abrir modal
        axios.put(`/Permisos/ConfigurarAlertaMantenimiento/${item.idRol}`, {
          activar: false,
          correo: false,
          celular: false
        }).then(() => {
          this.getRoles(); // actualiza la tabla
        }).catch(() => {
          this.$toast?.error?.("Error al desactivar alerta");
        });
      }
    },
    onAlarmaParoChange(item, valor) {
      this.currentItem = item;

      if (valor) {
        this.showModal = true;
        this.cargarConfiguracionAlarma();
      } else {
        this.desactivarNotificacionParo();
      }
    },
    getAreas() {
      return axios.get("/Areas")
        .then((response) => {
          this.areas = response.data.filter((a) => a.idArea > 1);
        });
    },
    onAreaChange() {
      this.usuarios = [];
      this.maquinasIns = [];

      return axios.get(`/Permisos/UsuariosRol/${this.currentItem.idRol}`)
        .then(resp => {
          this.usuarios = resp.data;
        })
        .then(() => {
          return axios.get("/MaquinaInstancias")
            .then((response) => {
              this.maquinasIns = response.data;
            });
        });
    },
    onUsuarioChange() {
      axios.get(`/Permisos/TurnosUsuario`)
        .then(resp => {
          this.$set(this.alarma, 'listaTurnos', resp.data);

        })
        .catch(err => {
          console.error(err);
          this.$set(this.alarma, 'listaTurnos', []);
          this.alarma.turnoSeleccionado = null;
        });
    },
    cerrarDialogAlerta() {
      this.dialogAlerta = false;

      if (this.configurandoDesdeSwitch && this.currentItem) {
        this.currentItem.llamarMantenimiento = false; // desmarca visual
      }

      this.configAlerta = {
        idRol: null,
        correo: false,
        sms: false
      };

      this.configurandoDesdeSwitch = false;
      //this.mensajeErrorAlarma = "";
    },
    confirmarActivacion() {
      //this.mensajeErrorAlarma = "";  // limpiamos errores previos

      // Validar que al menos una máquina, área o turno estén seleccionados (si quieres permitir vacíos, omite estas)
      //if (
      //  (!this.alarma.areaSeleccionada || this.alarma.areaSeleccionada.length === 0) &&
      //  (!this.alarma.turnoSeleccionado || this.alarma.turnoSeleccionado.length === 0) &&
      //  (!this.alarma.maquinasSeleccionadas || this.alarma.maquinasSeleccionadas.length === 0)
      //) {
      //  this.mensajeErrorAlarma = "Debe seleccionar al menos un Área, Turno o Máquina.";
      //  return;
      //}

      // Validar formato correcto (aunque ahora todos son opcionales, excepto tiempo si lo deseas obligatorio)
      //if (
      //  this.alarma.tiempoSeleccionado !== null &&
      //  this.alarma.tiempoSeleccionado !== undefined &&
      //  this.tiempos.find(t => t.value === this.alarma.tiempoSeleccionado) === undefined
      //) {
      //  this.mensajeErrorAlarma = "Tiempo de alarma inválido.";
      //  return;
      //}

      const configuracion = {
        idRol: this.currentItem.idRol,
        idSubSeccion: 4,
        idMedioEnvio: this.alarma.medioEnvio ?? null,
        activo: this.alarma.activo ?? false,
        mantenimiento: true,
        llamadoMantenimiento: false,
        idAreaEnvio: this.alarma.areaSeleccionada ?? [],       // JSON en backend
        idTurnoSeleccionado: this.alarma.turnoSeleccionado ?? [],
        idTiempoSeleccionado: this.alarma.tiempoSeleccionado ?? null,
        tiempoAcumuladoMinutos: this.alarma.tiempoAcumulado ?? null,
        idMaquinaIns: this.alarma.maquinasSeleccionadas ?? [], // JSON en backend
        activar: true,
        correo: null,
        celular: null,
        condicion: true
      };

      axios.put('/Permisos/ConfiguracionAdicionalAlertas', configuracion)
        .then(() => { 
          this.$toast?.success?.('Configuración guardada');
          this.getRoles();
        })
        .catch(err => { 
          this.$toast?.error?.('Error al guardar');
          console.error(err);
        });

      this.resetModal();
    },
    cargarConfiguracionAlarma() {
      axios.get(`/Permisos/ObtenerConfiguracionAdicionalAlertas/${this.currentItem.idRol}`)
        .then(response => {
          const data = response.data;
          this.alarma.areaSeleccionada = data.idAreaEnvio ?? null;
          //this.alarma.usuarioSeleccionado = data.idUsuario ?? null;
          this.alarma.turnoSeleccionado = data.idTurnoSeleccionado ?? null;
          this.alarma.medioEnvio = data.idMedioEnvio ?? null;
          this.alarma.tiempoSeleccionado = null;
          if (data.idTiempoSeleccionado != null) {
            const existeTiempo = this.tiempos.some(t => t.value === data.idTiempoSeleccionado);
            if (existeTiempo) {
              this.alarma.tiempoSeleccionado = data.idTiempoSeleccionado;
            }
          }
          this.alarma.tiempoAcumulado = data.tiempoAcumuladoMinutos;
          this.alarma.activo = true;
          this.alarma.maquinasSeleccionadas = Array.isArray(data.idMaquinaIns)
          ? data.idMaquinaIns : [];

          // Ahora sí: llamamos getAreas() correctamente
          this.getAreas().then(() => {
            this.onAreaChange().then(() => {
              // Esperamos que usuarios, maquinas y turnos ya estén cargados
              this.onUsuarioChange();
            });
          });
        })
        .catch(() => {
          this.resetModal();
          this.alarma.activo = false;
        });
    },
    desactivarNotificacionParo() {
      const configuracion = {
        idRol: this.currentItem.idRol,
        idMedioEnvio: this.currentItem.medioEnvio,
        activo: null,
      };

        axios.put('/Permisos/ConfiguracionAdicionalAlertas', configuracion)
        .then(() => {
          this.getRoles();
        })
        .catch(err => {
          console.error(err);
          this.$toast?.error?.('Error al desactivar');
        });
    },
    cancelarActivacion() {
      if (this.currentItem) {
        this.currentItem.alarmaParo = false;  // Restauramos el switch visualmente
      }
      this.resetModal();
    },

    resetModal() {
      this.showModal = false;
      this.currentItem = null;
      this.alarma = {
        areaSeleccionada: null,
        //usuarioSeleccionado: null,
        turnoSeleccionado: null,
        listaTurnos: [],
        maquinasSeleccionadas: [],
        tiempoSeleccionado: null,
        tiempoAcumulado: null,
        activo: true
      };
      this.areas = [];
      this.usuarios = [];
      this.maquinas = [];
    },
    seleccionaColumna(event){
      event.items.forEach( item => {
        this.seleccionaFila({
          item: {...item},
          value: event.value
        });
      })
    },
    seleccionaFila(event){
      this.acciones.forEach( accion => {
        this.permisos[event.item.idVista][accion.idAccion] = event.value;
      });
    },
    initialize() {
      this.getInformacion();
      this.getRoles();
      this.getReportes();
    },
    getRoles(){
      this.loadingRoles = true;
      axios
        .get("/Permisos/Roles")
        .then((response) => {
          this.roles = response.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loadingRoles = false;
        });
    },
    getInformacion() {
      let me = this;
      me.loadingInfo = true;
      axios
        .get("/Permisos/Informacion")
        .then((response) => {
          if (me.desconocidos) me.secciones = response.data.secciones;
          else {
            me.secciones = response.data.secciones;
            me.secciones.sort((x, y) => {
              return x.posicion - y.posicion;
            }); //? Organizamos secciones por posicion
            me.secciones.forEach(function (seccion) {
              seccion.vistas = seccion.vistas.filter(function (vista) {
                return me.desconocidosIds.indexOf(vista.idVista) == -1;
              });
            });
          }
          me.acciones = response.data.acciones;
          me.permisos = {};
          this.resetPermisos();
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          me.loadingInfo = false;
        });
    },
    editItem(item) {
      let me = this;
      this.editedIndex = this.roles.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.resetPermisos();
      this.secciones.forEach(function (seccion) {
        seccion.vistas.forEach(function (vista) {
          me.permisos[vista.idVista] = {};
        });
      });
      item.permisos.forEach((element) => {
        if (!this.desconocidos) {
          if (this.desconocidosIds.indexOf(element.idVista) !== -1) return;
        }

        if(me.permisos[element.idVista]!=null){
          me.permisos[element.idVista][element.idAccion] = true;
        }
      });
      this.preSelect(item.permisos);
      this.dialog = true;
    },
    configurarAlertaMantenimiento(idRol, activar, correo, celular) {
      try {
        const response = 
        axios
          .put(`/Permisos/ConfigurarAlertaMantenimiento/${idRol}`, {
            activar: activar,
            correo: correo,
            celular: celular
        });

        console.log('Alerta configurada:', response.data);
      } catch (error) {
        console.error('Error al configurar alerta:', error);
      }
    },
    preSelect(itemPermisos){
      itemPermisos.forEach( permiso => {
        if(this.permisos[permiso.idVista]==undefined) return;
        if(
          this.permisos[permiso.idVista][1] &&
          this.permisos[permiso.idVista][2] &&
          this.permisos[permiso.idVista][3] &&
          this.permisos[permiso.idVista][4] &&
          this.permisos[permiso.idVista][5]
        ){
          this.secciones.forEach((seccion) => {
            seccion.vistas.forEach( (vista) => {
              if(vista.idVista==permiso.idVista){
                this.selected.push(vista);
              }
            });
          });
        }
      });
    },
    abrirDialogAlerta(item) {
      this.configAlerta.idRol = item.idRol;
      this.dialogAlerta = true;

      axios.get(`/Permisos/ObtenerAlertaMantenimiento/${item.idRol}`)
        .then(response => {
          this.configAlerta.correo = response.data.correo;
          this.configAlerta.sms = response.data.celular;
        })
        .catch(() => {
          // Si no hay alerta previa, deja los checkboxes en false
          this.configAlerta.correo = false;
          this.configAlerta.sms = false;
        });
    },

    guardarConfiguracionAlerta() {
      // Validación: al menos uno debe estar activado
      //if (!this.configAlerta.correo && !this.configAlerta.sms) {
      // this.mensajeErrorAlarma = "Debe seleccionar al menos un medio de notificación (Correo o Mensaje).";
      //  return;
      //}

      axios.put(`/Permisos/ConfigurarAlertaMantenimiento/${this.configAlerta.idRol}`, {
        activar: true,
        correo: this.configAlerta.correo,
        celular: this.configAlerta.sms
      })
      .then(() => {
        if (this.configurandoDesdeSwitch && this.currentItem) {
          this.currentItem.llamarMantenimiento = true; // asegura que quede activado
        }

        this.dialogAlerta = false;
        this.configAlerta.correo = false;
        this.configAlerta.sms = false;
        this.configurandoDesdeSwitch = false;
        //this.mensajeErrorAlarma = "";
        this.getRoles();
      })
      .catch(err => {
        console.error(err);
        this.$toast?.error?.("Error al guardar configuración");
      });
    },
    deleteItem(item) {
      this.eliminar = true;
      this.delItem = item;
    },
    deleteItemDB() {
      let me = this;
      let item = this.delItem;
      this.delItem = "";
      axios
        .put("/Permisos/Desactivar/" + item.idRol)
        .then((response) => {
          me.initialize();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    close() {
      this.dialog = false;
      this.editedItem = Object.assign({}, this.defaultItem);
      this.selected = [];
      this.errores = [];
      this.resetPermisos();
      this.editedIndex = -1;
    },
    validate() {
      this.errores = [];
      if (
        this.editedItem.nombre.length < 5 ||
        this.editedItem.nombre.length > 50
      ) {
        this.errores[0] =
          "El nombre debe tener más de 4 caracteres y menos de 50.";
      }
      if (this.editedItem.descripcion.length < 5) {
        this.errores[1] = 
          "La descripción debe tener de tener al menos 5 caracteres";
      }

      return this.errores.length==0;
    },
    save() {
      if (this.validate()) {
        let me = this;
        me.saving = true;
        let permisosL = [];
        me.secciones.forEach(function (seccion) {
          seccion.vistas.forEach(function (vista) {
            me.acciones.forEach(function (accion) {
              if (me.permisos[vista.idVista][accion.idAccion] == true) {
                permisosL.push({
                  idVista: vista.idVista,
                  idAccion: accion.idAccion,
                });
              }
            });
          });
        });
        if (this.editedIndex > -1) {
          //Código para editar
          axios
            .put("/Permisos/Actualizar/" + me.roles[me.editedIndex].idRol, {
              Nombre: me.editedItem.nombre,
              Descripcion: me.editedItem.descripcion,
              IdsReportes:me.editedItem.idsReportes,
              Permisos: permisosL,
            })
            .then((response) => {
              me.saving = false;
              me.close();
              me.initialize();
            })
            .catch((error) => {
              me.saving = false;
              if (error.response) {
                if (error.response.status == 409) {
                  me.alerta = true;
                  me.errores.push("Existe un Rol Activo con el Mismo Nombre");
                }
              }
            });
        } else {
          axios
            .post("/Permisos/Crear", {
              Nombre: me.editedItem.nombre,
              Descripcion: me.editedItem.descripcion,
              IdsReportes:me.editedItem.idsReportes,
              Permisos: permisosL,
            })
            .then((response) => {
              me.saving = false;
              me.close();
              me.initialize();
            })
            .catch((error) => {
              me.saving = false;
              if (error.response) {
                if (error.response.status == 409) {
                  me.alerta = true;
                  me.errores.push("Existe un Rol Activo con el Mismo Nombre");
                }
              }
            });
        }
      }
    },
    resetPermisos() {
      this.secciones.forEach((seccion) => {
        seccion.vistas.forEach((vista) => {
          this.permisos[vista.idVista] = {};
          this.acciones.forEach((accion) => {
            this.permisos[vista.idVista][accion.idAccion] = false;
          });
        });
      });
    },
    getReportes(){
      this.loadingReportes = true;
      axios
      .get('/CatReportes/ReportesDisponibles')
      .then(response => {
        this.reportes=response.data;
      })
      .catch(error => {
        console.log(error)
      })
      .finally(() => {
        this.loadingReportes = false;
      });
    }
    // resetFilas(){
    //   this.secciones.forEach((seccion) => {
    //     this.contadorSec = 0;
    //     seccion.vistas.forEach((vista) => {
    //       this.contador = 0;
    //       this.acciones.forEach((accion) => {
    //         if ( this.permisos[vista.idVista][accion.idAccion] ) this.contador += 1; 
    //       });
    //       this.filas[vista.idVista] = this.contador === 5 ? true : false; 
    //       if ( this.filas[vista.idVista] ) this.contadorSec += 1;
    //     });
    //     this.seleccionados[seccion.idSeccion] = this.contadorSec === seccion.vistas.length ? [{}] : [];
    //   });
    // },
  },
};
</script>
